import React from 'react';
import styled from 'styled-components';
import { SolvStyledTab } from '../../../../SimpleTabs';
import { KEY_NO_SCALE } from '../constants/animatedValues';
import { fontSize } from '../../../../../../constants/text';

const AnimatedTabs = styled(SolvStyledTab).withConfig({ componentId: 'sc-1jicmc4-0' })`
  && .tab-label {
    font-size: ${fontSize.medium};
  }

  && .animated {
    animation: ${KEY_NO_SCALE} 300ms ease;
    animation-fill-mode: both;
    animation-direction: normal;
  }
`;

AnimatedTabs.propTypes = SolvStyledTab.propTypes;

export default AnimatedTabs;
